<template>
  <div id="app">
    <b-modal @close="closeIEModal" :active.sync="isIEModalShow" has-modal-card scroll="keep">
      <IEModal @close-modal="closeIEModal" />
    </b-modal>

    <NavbarAuthorized v-if="isAuth" @open-modal="showModal" @open-sidebar="openSideBar" />

    <NavbarUnAuthorized v-else @open-modal="showModal" @open-sidebar="openSideBar" />

    <NavbarSidebar
      @openAccount="openAccount"
      :class="isSideBarOpen ? 'active' : ''"
      @close-sidebar="closeSideBar"
      @open-modal="showModal"
    />

    <div class="account_content" :class="isAuth ? userRole + ' is-auth ' + $route.name : $route.name">
      <router-view />

      <UserRightBlock
        :course-info="courseInfo"
        :stages-list="stagesList"
        v-if="userRole === 'user' && $route.name !== 'home'"
      />

      <LeaderRightBlock
        :course-info="courseInfo"
        :stages-list="stagesList"
        v-if="(userRole === 'leader' || userRole === 'leader_admin') && $route.name !== 'home'"
      />

      <AdminRightBlock
        :course-info="courseInfo"
        :stages-list="stagesList"
        :hide-branches-list="$route.name === 'course-info_id'"
        v-if="(userRole === 'admin' || userRole === 'methodist') && $route.name !== 'home'"
      />
    </div>

    <FooterBlock />

    <b-modal @close="closeModal" :active.sync="isModalShow" has-modal-card scroll="keep">
      <SignInModal @open-modal="showResetModal" @close-modal="closeModal" />
    </b-modal>

    <b-modal @close="closeResetModal" :active.sync="isResetModalShow" has-modal-card scroll="keep">
      <ResetModal @close-modal="closeResetModal" />
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import '@/assets/sass/app.sass'
import NavbarAuthorized from '@/components/navbar/authorized'
import NavbarUnAuthorized from '@/components/navbar/unauthorized'
import SignInModal from '@/components/signin'
import IEModal from '@/components/IEModal'
import ResetModal from '@/components/reset'
import NavbarSidebar from '@/components/navbar/navbarSidebar'
import FooterBlock from '@/components/FooterBlock'
import UserRightBlock from '@/components/right_block/user'
import LeaderRightBlock from '@/components/right_block/leader'
import AdminRightBlock from '@/components/right_block/admin'

export default {
  components: {
    SignInModal,
    NavbarSidebar,
    FooterBlock,
    ResetModal,
    NavbarAuthorized,
    NavbarUnAuthorized,
    IEModal,
    UserRightBlock,
    AdminRightBlock,
    LeaderRightBlock
  },
  data() {
    return {
      isModalShow: false,
      isIEModalShow: this.$browserDetect.isIE ? true : false,
      isResetModalShow: false,
      isSideBarOpen: false
    }
  },
  methods: {
    showModal() {
      this.isModalShow = true
      this.isSideBarOpen = false
    },
    closeModal() {
      this.isModalShow = false
    },
    closeIEModal() {
      this.isIEModalShow = false
    },
    showResetModal() {
      this.isResetModalShow = true
      this.isSideBarOpen = false
      this.isModalShow = false
    },
    closeResetModal() {
      this.isResetModalShow = false
      this.isModalShow = true
    },
    openSideBar() {
      this.isSideBarOpen = true
    },
    closeSideBar() {
      this.isSideBarOpen = false
    },
    openAccount() {
      this.closeSideBar()
      this.$router.push('/profile')
    }
  },
  computed: {
    userRole() {
      return this.$store.state.auth.role[0]
    },
    isAuth() {
      return this.$store.state.auth.auth
    },
    stagesList() {
      return this.$store.state.courses.infoStagesList
    },
    courseInfo() {
      let data = this.$store.state.courses.coursePageInfo
      const currentCategory = this.categoriesList.find((el) => el.id === data.category_id)
      if (!currentCategory) {
        return data
      }
      data['category_name'] = currentCategory.name
      return data
    },
    categoriesList() {
      return this.$store.state.categories.categoriesList
    }
  },
  mounted() {
    this.$axios2
      .get('categories')
      .then((resp) => {
        this.$store.commit('setCategoriesList', { list: resp.data })
        this.$axios2
          .get('courses/list?category_id=' + resp.data[0].id)
          .then((response) => {
            this.$store.commit('setCategoryCoursesList', {
              list: response.data,
              index: 0
            })
          })
          .catch(this.$errorToast)
      })
      .catch(this.$errorToast)
    this.$axios2
      .get('categories?all=true')
      .then((resp) => {
        this.$store.commit('setModalCategoriesList', { list: resp.data })
      })
      .catch(this.$errorToast)
    if (!this.isAuth) {
      return
    }
    this.$axios2
      .get('notifications?unread')
      .then((resp) => {
        this.$store.commit('setUnreadNotificationsList', { list: resp.data })
      })
      .catch(this.$errorToast)
  }
}
</script>

<style>
@import url(./assets/fonts/fonts.css);
@import url(./assets/fonts/fontello/css/fontello.css);
@import url(./assets/css/swiper.min.css);
</style>
